import { appProductTypes, BillCategoryKey } from '@1bill-app/services/bill/types';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-product-categories',
  templateUrl: './product-categories.component.html',
  styleUrls: ['./product-categories.component.scss'],
})
export class ProductCategoriesComponent implements OnInit {
  @Output() catSelected = new EventEmitter<string>();
  productCategories = appProductTypes.filter(val=>val.inAddBill);
  constructor() {
   }

  ngOnInit() {}

  clicked(key){
    this.catSelected.emit(key);
  }

}
